var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.39866 0.48728C1.26684 -0.0783109 0.0140579 1.00157 0.406108 2.20432L2.94842 9.99782C3.02032 10.218 3.15122 10.4142 3.32687 10.5652C3.50252 10.7162 3.71621 10.8161 3.94469 10.8541L13.9898 12.5281C14.5186 12.6168 14.5186 13.3768 13.9898 13.4655L3.94532 15.1394C3.71684 15.1774 3.50316 15.2774 3.3275 15.4283C3.15185 15.5793 3.02095 15.7756 2.94905 15.9957L0.406108 23.7937C0.0134246 24.9971 1.26684 26.0769 2.39866 25.5113L24.8791 14.2743C25.9299 13.7486 25.9299 12.2494 24.8791 11.7244L2.39866 0.48728Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.9b8009f8068203c1c710e11be852aebb.svg";
export { ForwardRef as ReactComponent };